import React, { useEffect, useState } from 'react';

export default function BlogBackToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 520);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-4 z-40 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white/95 px-4 py-3 text-xs font-black uppercase tracking-[0.18em] text-slate-700 shadow-[0_16px_40px_-24px_rgba(15,23,42,0.45)] backdrop-blur transition hover:-translate-y-0.5 hover:border-primary/40 hover:text-primary dark:border-slate-800 dark:bg-slate-950/95 dark:text-slate-200 dark:hover:text-primary md:bottom-8 md:right-8"
      aria-label="Sayfanın başına dön"
    >
      <span className="material-symbols-outlined text-base">arrow_upward</span>
      <span>Yukarı Çık</span>
    </button>
  );
}
